import React, { useState } from 'react';

//-----------------------------------------------------------------------------------------
// Type Definitions:
//-----------------------------------------------------------------------------------------

enum InputTypes {
	Email = 'email',
	Tel = 'tel',
}

export type Input = {
	id: string;
	placeholder: string;
	required?: boolean;
	maxLength?: number;
}

interface FormInputProps {
	handleUpdateInput: (key: string, value: string) => void;
	inputValue: string;
	input: Input;
	handleInvalidInput?: () => void;
}

//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

export default function FormInput(props: FormInputProps) {

	// access input prop.

	const { input } = props;

	// states.

	const [isValid, setIsValid] = useState(true);

	// handlers.

	const handleInputValidation = (value: string) => {

		// toggle input validation.
		const checkValidation = validateInput(value, input.id, input.required);
		setIsValid(checkValidation);

		if (!checkValidation && props.handleInvalidInput) {
			props.handleInvalidInput();
		}
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		handleInputValidation(e.target.value);
		props.handleUpdateInput(input.id, e.target.value);
	}

	// return the HTML.
	return (
		<div>
			<input
				type={input.id === InputTypes.Tel ? 'tel' : 'text'}
				placeholder={`${input.placeholder} ${input .required ? '*' : ''}`}
				onChange={handleChange}
				value={props.inputValue}
				required={input.required}
				maxLength={input.maxLength || 100}
			/>
			{!isValid && <p id="invalid-input-error">{input.placeholder} is required</p>}
		</div>
	);
}

//-----------------------------------------------------------------------------------------
// Private Components:
//-----------------------------------------------------------------------------------------

// check input value against the input type using regex.
const validateInput = (inputValue: string, inputType: string, required?:boolean) => {
	if (inputType === InputTypes.Email) {
		const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputValue);
		return isValid;
	}  else if (required) {
		return Boolean(inputValue);
	} else {
		return true;
	}
};
